import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import {
  adaptQuizToApi,
  adaptQuizToStore,
  adaptQuizzesToStore,
  adaptQuestionToStore,
  adaptQuestionToApi,
  adaptAnswerToStore,
  adaptAnswerToApi
} from './adapters/quizAdapter'
import {
  buildHeaders
} from './utils/build_headers'
import { QUIZ, CONTENT_BACKOFFICE } from '@/services/axios.config'

const services = [
  {
    name: 'listQuizzes',
    method: 'get',
    url: (params) => `/quizzes${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptQuizzesToStore
  },
  {
    name: 'getQuiz',
    method: 'get',
    url: (params) => `/quizzes/${params.quizId}`,
    resolver: adaptQuizToStore
  },
  {
    name: 'createQuiz',
    method: 'post',
    url: () => `/quizzes`,
    data: (params) => {
      return adaptQuizToApi(params)
    },
    resolver: adaptQuizToStore
  },
  {
    name: 'editQuiz',
    method: 'put',
    url: (params) => `/quizzes/${params.quizId}`,
    data: (params) => {
      return adaptQuizToApi(params)
    },
    resolver: adaptQuizToStore
  },
  /* QUESTIONS */
  {
    name: 'getQuestion',
    method: 'get',
    url: (params) => `/quizzes/${params.quizId}/questions/${params.questionId}`,
    resolver: adaptQuestionToStore
  },
  {
    name: 'createQuestion',
    method: 'post',
    url: (params) => `/quizzes/${params.quizId}/questions`,
    data: (params) => {
      return adaptQuestionToApi(params.question)
    },
    resolver: adaptQuestionToStore
  },
  {
    name: 'editQuestion',
    method: 'put',
    url: (params) => `/quizzes/${params.quizId}/questions/${params.questionId}`,
    data: (params) => {
      return adaptQuestionToApi(params.question)
    },
    resolver: adaptQuestionToStore
  },
  {
    name: 'deleteQuestion',
    method: 'delete',
    url: (params) => `/quizzes/${params.quizId}/questions/${params.questionId}`
  },
  /* ANSWERS */
  {
    name: 'getAnswer',
    method: 'get',
    url: (params) => `/quizzes/${params.quizId}/questions/${params.questionId}/answers/${params.answerId}`,
    resolver: adaptAnswerToStore
  }, {
    name: 'createAnswer',
    method: 'post',
    url: (params) => `/quizzes/${params.quizId}/questions/${params.questionId}/answers`,
    data: (params) => {
      return adaptAnswerToApi(params.answer)
    },
    resolver: adaptAnswerToStore
  }, {
    name: 'editAnswer',
    method: 'put',
    url: (params) => `/quizzes/${params.quizId}/questions/${params.questionId}/answers/${params.answerId}`,
    data: (params) => {
      return adaptAnswerToApi(params.answer)
    },
    resolver: adaptAnswerToStore
  }, {
    name: 'deleteAnswer',
    method: 'delete',
    url: (params) => `/quizzes/${params.quizId}/questions/${params.questionId}/answers/${params.answerId}`
  },
  {
    name: 'uploadFile',
    method: 'post',
    url: (params) => `/quizzes/upload?company=${params.company}`,
    headersFactory: buildHeaders({
      'Content-Type': undefined
    }),
    data: (params) => {
      return params.file
    }
  }
]

export const {
  getQuiz,
  createQuiz,
  editQuiz,
  listQuizzes,
  getQuestion,
  createQuestion,
  editQuestion,
  deleteQuestion,
  getAnswer,
  createAnswer,
  editAnswer,
  deleteAnswer,
  uploadFile
} = buildServices(QUIZ, services)

const backofficeServices = [
  {
    name: 'insertQuizzesAfterVideos',
    method: 'post',
    url: () => `/quizzes/insert-after-videos`,
    data: (params) => params
  }
]

export const {
  insertQuizzesAfterVideos
} = buildServices(CONTENT_BACKOFFICE, backofficeServices)